<template>
  <div>
    <!-- 付完款页末分批付款 -->
    <div class="content">
      <!-- 订单支付方式 -->
      <div class="block-item" style="width: 340px;">
        <h6>{{ $t('message.orderPaymentMethod') }}</h6>
        <ul style="background-color: rgba(217, 240, 249, 0.847058823529412); ">
          <!-- 商品金额： -->
          <li>
            <div class="item">{{ $t("message.goodsAmount") }} (首付)</div>
            <div class="item">{{ ceil(firstKin.goods_amount) }} 元</div>
          </li>
          <!-- 国内运费 -->
          <li>
            <div class="item">{{ $t("message.domesticFreight") }}</div>
            <div class="item">{{ firstKin.is_pay_freight_amount ? $t('message.payOnFirstPayment') :
              $t('message.payWithTheBalance') }}</div>

          </li>
          <!-- 手续费 -->
          <li>
            <div class="item">{{ $t("message.poundage") }}</div>
            <div class="item">{{ firstKin.is_pay_service_amount ? $t('message.payOnFirstPayment') :
              $t('message.payWithTheBalance') }}</div>
          </li>
          <!-- 附加服务费 -->
          <li>
            <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
            <div class="item">{{ firstKin.is_pay_option_amount ? $t('message.payOnFirstPayment') :
              $t('message.payWithTheBalance') }}</div>
          </li>
          <!-- 其他费用： -->
          <li>
            <div class="item">{{ $t("message.otherFees") }}</div>
            <div class="item">{{ firstKin.is_pay_other_amount ? $t('message.payOnFirstPayment') :
              $t('message.payWithTheBalance') }}</div>
          </li>
          <!-- 尾款支付节点： -->
          <li>
            <div class="item">{{ $t("message.finalPaymentNode") }}</div>
            <div class="item">{{ firstKin.must_pay_node ? $t('message.preWarehouse') :
              $t('message.beforeDeliveryOrder') }}</div>
          </li>
        </ul>
      </div>
      <!-- 首款 -->
      <div class="block-item">
        <h6>{{ $t('message.theFirst') }} <span class="fr">支付状态：{{ firstKin.pay_status_name }}</span></h6>
        <ul style="background-color: rgba(251, 228, 230);">
          <!-- 商品金额： -->
          <li>
            <div class="item">{{ $t("message.goodsAmount") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(firstKin.goods_amount) }} 元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen((firstKin.goods_amount * rate)) }} 円</div>
          </li>
          <!-- 国内运费 -->
          <li>
            <div class="item">{{ $t("message.domesticFreight") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(firstKin.freight_amount) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(firstKin.freight_amount * rate) }} 円</div>
          </li>
          <!-- 手续费 -->
          <li>
            <div class="item">{{ $t("message.poundage") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(firstKin.service_amount) }} 元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(firstKin.service_amount * rate) }} 円</div>
          </li>
          <!-- 附加服务费 -->
          <li>
            <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(firstKin.option_amount) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(firstKin.option_amount * rate) }} 円</div>
          </li>
          <!-- 其他费用： -->
          <li>
            <div class="item">{{ $t("message.otherFees") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(firstKin.other_amount) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(firstKin.other_amount * rate) }} 円</div>
          </li>

          <!-- 合计 -->
          <li>
            <div class="item">{{ $t("message.total") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(firstKin.total) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(firstKin.total * rate) }} 円</div>
          </li>
        </ul>
      </div>
      <!-- 尾款 -->
      <div class="block-item">
        <h6>{{ $t('message.balancePayment') }} <span class="fr">支付状态：{{ lastKin.pay_status_name }}</span></h6>
        <ul style="background-color: rgba(250, 205, 145);">
          <!-- 商品金额： -->
          <li>
            <div class="item">{{ $t("message.goodsAmount") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(lastKin.goods_amount) }} 元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen((lastKin.goods_amount * rate)) }} 円</div>
          </li>
          <!-- 国内运费 -->
          <li>
            <div class="item">{{ $t("message.domesticFreight") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(lastKin.freight_amount) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(lastKin.freight_amount * rate) }} 円</div>
          </li>
          <!-- 手续费 -->
          <li>
            <div class="item">{{ $t("message.poundage") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(lastKin.service_amount) }} 元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(lastKin.service_amount * rate) }} 円</div>
          </li>
          <!-- 附加服务费 -->
          <li>
            <div class="item">{{ $t("message.additionalServiceCharge") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(lastKin.option_amount) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(lastKin.option_amount * rate) }} 円</div>
          </li>
          <!-- 其他费用： -->
          <li>
            <div class="item">{{ $t("message.otherFees") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(lastKin.other_amount) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(lastKin.other_amount * rate) }} 円</div>
          </li>

          <!-- 合计 -->
          <li>
            <div class="item">{{ $t("message.total") }}</div>
            <!-- 人民币 -->
            <div class="item">{{ ceil(lastKin.total) }}元</div>
            <!-- 日元 -->
            <div class="item"> {{ ceilYen(lastKin.total * rate) }} 円</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    order_part_pay: { type: Array },
    rate: { type: Number },
  },
  computed: {

    // 订单支付方式
    datas() {
      return this.order_part_pay[0]
    },
    // 首付款
    firstKin() {
      let firstKin = this.order_part_pay[0]
      firstKin.total = (firstKin.other_amount - 0) + (firstKin.option_amount - 0) + (firstKin.service_amount - 0) + (firstKin.freight_amount - 0) + (firstKin.goods_amount - 0)
      return firstKin
    },
    // 尾款
    lastKin() {
      let lastKin = this.order_part_pay[1]
      lastKin.total = (lastKin.other_amount - 0) + (lastKin.option_amount - 0) + (lastKin.service_amount - 0) + (lastKin.freight_amount - 0) + (lastKin.goods_amount - 0)
      return lastKin
    },

  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.content {
  margin: 24px;
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;

  .block-item {
    width: 500px;
    margin-bottom: 38px;



    margin-right: 38px;


    h6 {
      font-size: 20px;
      font-weight: 600;
      color: #B4272D;
      margin-bottom: 20px;
    }

    ul {
      border: 1px solid #ccc;

      li {
        display: flex;
        border-bottom: 1px solid #ccc;

        &:nth-last-child(1) {
          border: 0;
        }

        .item {
          flex: 1;
          border-right: 1px solid #ccc;
          padding: 10px;

          &:nth-last-child(1) {
            border: 0;
          }
        }

        .item2 {
          flex: 2;
          padding: 5px 20px;

        }
      }
    }

    // background-color: pink;
  }
}
</style>